module.exports = __webpack_public_path__ + "media/images/desktop/story-script_tap-visual@2x-77371f325cf01fcd89c6537657f847bb.png";